import {
  NumberEmployeeRangeEnum,
  PackageObject,
  PayFitPackages,
  PayfitPackageEnum,
  SimplifiedSimulatorValues,
} from './types';

const rhPlus = 'RH+';
const paieAvancee = 'Paie Avancée';

// Total payroll process efficiency gains (risk adjusted) by month by employee in euros
// Use Math.ceil() and x12 to compute yearly results
export const payrollProcessEfficiencyGains: PackageObject = {
  [PayfitPackageEnum[rhPlus]]: 50.4,
  [PayfitPackageEnum.Paie]: 40.8,
  [PayfitPackageEnum[paieAvancee]]: 50.4,
  [PayfitPackageEnum.Premium]: 50.4,
};

// Expense management efficiency gain (risk adjusted) by month by employee in euros
// Use Math.ceil() and x12 to compute yearly results
export const expenseManagementEfficiencyGain: PackageObject = {
  [PayfitPackageEnum[rhPlus]]: 36,
  [PayfitPackageEnum.Paie]: 0,
  [PayfitPackageEnum[paieAvancee]]: 36,
  [PayfitPackageEnum.Premium]: 36,
};

// Cost avoidance (risk adjusted) by month by employee in euros
// Use Math.ceil() and x12 to compute yearly results
export const costAvoidance: PackageObject = {
  [PayfitPackageEnum[rhPlus]]: 33.8,
  [PayfitPackageEnum.Paie]: 33.8,
  [PayfitPackageEnum[paieAvancee]]: 33.8,
  [PayfitPackageEnum.Premium]: 33.8,
};

// Performance management gains (risk adjusted 5%) by month by employee in euros
// Use Math.ceil() and x12 to compute yearly results
export const timeSavingsOnPerformanceManagement: PackageObject = {
  [PayfitPackageEnum[rhPlus]]: 6 * 0.95,
  [PayfitPackageEnum.Paie]: 0 * 0.95,
  [PayfitPackageEnum[paieAvancee]]: 0 * 0.95,
  [PayfitPackageEnum.Premium]: 6 * 0.95,
};

// Staff management efficiency gains (risk adjusted) by month by employee in euros
// Use Math.ceil() and x12 to compute yearly results
export const staffManagementEfficiencyGains: PackageObject = {
  [PayfitPackageEnum[rhPlus]]: 4.99,
  [PayfitPackageEnum.Paie]: 0,
  [PayfitPackageEnum[paieAvancee]]: 2.85,
  [PayfitPackageEnum.Premium]: 4.99,
};

// Planning, implementation & change management costs (risk adjusted) in euros
export const planningImplementationCosts: any = {
  [PayfitPackageEnum[rhPlus]]: 1752,
  [PayfitPackageEnum.Paie]: 1752,
  [PayfitPackageEnum[paieAvancee]]: 1752,
  [PayfitPackageEnum.Premium]: 1752,
};

export const simplifiedSimulatorValues: SimplifiedSimulatorValues[] = [
  { label: '1', value: '-936' },
  { label: '2', value: '228' },
  { label: '3', value: '1 392' },
  { label: '4', value: '2 196' },
  { label: '5', value: '3 360' },
  { label: '6', value: '4 524' },
  { label: '7', value: '5 688' },
  { label: '8', value: '6 852' },
  { label: '9', value: '8 016' },
  { label: '10', value: '8 700' },
  { label: '11', value: '9 864' },
  { label: '12', value: '11 028' },
  { label: '13', value: '12 192' },
  { label: '14', value: '13 356' },
  { label: '15', value: '14 520' },
  { label: '16', value: '15 684' },
  { label: '17', value: '16 848' },
  { label: '18', value: '18 012' },
  { label: '19', value: '19 176' },
  { label: '20', value: '20 340' },
  { label: '21', value: '21 504' },
  { label: '22', value: '22 668' },
  { label: '23', value: '23 832' },
  { label: '24', value: '24 996' },
  { label: '25', value: '25 560' },
  { label: '26', value: '26 724' },
  { label: '27', value: '27 888' },
  { label: '28', value: '29 052' },
  { label: '29', value: '30 216' },
  { label: '30', value: '31 380' },
  { label: '31', value: '32 544' },
  { label: '32', value: '33 708' },
  { label: '33', value: '34 872' },
  { label: '34', value: '36 036' },
  { label: '35', value: '37 200' },
  { label: '36', value: '38 364' },
  { label: '37', value: '39 528' },
  { label: '38', value: '40 692' },
  { label: '39', value: '41 856' },
  { label: '40', value: '43 020' },
  { label: '41', value: '44 184' },
  { label: '42', value: '45 348' },
  { label: '43', value: '46 512' },
  { label: '44', value: '47 676' },
  { label: '45', value: '48 840' },
  { label: '46', value: '50 004' },
  { label: '47', value: '51 168' },
  { label: '48', value: '52 332' },
  { label: '49', value: '53 496' },
  { label: '50', value: '54 660' },
  { label: '51', value: '55 824' },
  { label: '52', value: '56 988' },
  { label: '53', value: '58 152' },
  { label: '54', value: '59 316' },
  { label: '55', value: '60 480' },
  { label: '56', value: '61 644' },
  { label: '57', value: '62 808' },
  { label: '58', value: '63 972' },
  { label: '59', value: '65 136' },
  { label: '60', value: '66 300' },
  { label: '61', value: '67 464' },
  { label: '62', value: '68 628' },
  { label: '63', value: '69 792' },
  { label: '64', value: '70 956' },
  { label: '65', value: '72 120' },
  { label: '66', value: '73 284' },
  { label: '67', value: '74 448' },
  { label: '68', value: '75 612' },
  { label: '69', value: '76 776' },
  { label: '70', value: '77 940' },
  { label: '71', value: '79 104' },
  { label: '72', value: '80 268' },
  { label: '73', value: '81 432' },
  { label: '74', value: '82 596' },
  { label: '75', value: '83 760' },
  { label: '76', value: '84 924' },
  { label: '77', value: '86 088' },
  { label: '78', value: '87 252' },
  { label: '79', value: '88 416' },
  { label: '80', value: '89 580' },
  { label: '81', value: '90 744' },
  { label: '82', value: '91 908' },
  { label: '83', value: '93 072' },
  { label: '84', value: '94 236' },
  { label: '85', value: '95 400' },
  { label: '86', value: '96 564' },
  { label: '87', value: '97 728' },
  { label: '88', value: '98 892' },
  { label: '89', value: '100 056' },
  { label: '90', value: '101 220' },
  { label: '91', value: '102 384' },
  { label: '92', value: '103 548' },
  { label: '93', value: '104 712' },
  { label: '94', value: '105 876' },
  { label: '95', value: '107 040' },
  { label: '96', value: '108 204' },
  { label: '97', value: '109 368' },
  { label: '98', value: '110 532' },
  { label: '99', value: '111 696' },
  { label: '100', value: '112 860' },
  { label: '101', value: '114 024' },
  { label: '102', value: '115 188' },
  { label: '103', value: '116 352' },
  { label: '104', value: '117 516' },
  { label: '105', value: '118 680' },
  { label: '106', value: '119 844' },
  { label: '107', value: '121 008' },
  { label: '108', value: '122 172' },
  { label: '109', value: '123 336' },
  { label: '110', value: '124 500' },
  { label: '111', value: '125 664' },
  { label: '112', value: '126 828' },
  { label: '113', value: '127 992' },
  { label: '114', value: '129 156' },
  { label: '115', value: '130 320' },
  { label: '116', value: '131 484' },
  { label: '117', value: '132 648' },
  { label: '118', value: '133 812' },
  { label: '119', value: '134 976' },
  { label: '120', value: '136 140' },
  { label: '121', value: '137 304' },
  { label: '122', value: '138 468' },
  { label: '123', value: '139 632' },
  { label: '124', value: '140 796' },
  { label: '125', value: '141 960' },
  { label: '126', value: '143 124' },
  { label: '127', value: '144 288' },
  { label: '128', value: '145 452' },
  { label: '129', value: '146 616' },
  { label: '130', value: '147 780' },
  { label: '131', value: '148 944' },
  { label: '132', value: '150 108' },
  { label: '133', value: '151 272' },
  { label: '134', value: '152 436' },
  { label: '135', value: '153 600' },
  { label: '136', value: '154 764' },
  { label: '137', value: '155 928' },
  { label: '138', value: '157 092' },
  { label: '139', value: '158 256' },
  { label: '140', value: '159 420' },
  { label: '141', value: '160 584' },
  { label: '142', value: '161 748' },
  { label: '143', value: '162 912' },
  { label: '144', value: '164 076' },
  { label: '145', value: '165 240' },
  { label: '146', value: '166 404' },
  { label: '147', value: '167 568' },
  { label: '148', value: '168 732' },
  { label: '149', value: '169 896' },
  { label: '150', value: '171 060' },
  { label: '151', value: '172 224' },
  { label: '152', value: '173 388' },
  { label: '153', value: '174 552' },
  { label: '154', value: '175 716' },
  { label: '155', value: '176 880' },
  { label: '156', value: '178 044' },
  { label: '157', value: '179 208' },
  { label: '158', value: '180 372' },
  { label: '159', value: '181 536' },
  { label: '160', value: '182 700' },
  { label: '161', value: '183 864' },
  { label: '162', value: '185 028' },
  { label: '163', value: '186 192' },
  { label: '164', value: '187 356' },
];

export const payfitPackages: PayFitPackages[] = [
  // PAIE
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['1-3'],
    payfitPackage: PayfitPackageEnum.Paie,
    subscription: 49,
    subscriptionByPayroll: 17,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['4-9'],
    payfitPackage: PayfitPackageEnum.Paie,
    subscription: 79,
    subscriptionByPayroll: 17,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['10-24'],
    payfitPackage: PayfitPackageEnum.Paie,
    subscription: 99,
    subscriptionByPayroll: 17,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['25+'],
    payfitPackage: PayfitPackageEnum.Paie,
    subscription: 149,
    subscriptionByPayroll: 17,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  // PAIE AVANCEE
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['1-3'],
    payfitPackage: PayfitPackageEnum[paieAvancee],
    subscription: 49,
    subscriptionByPayroll: 25,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['4-9'],
    payfitPackage: PayfitPackageEnum[paieAvancee],
    subscription: 79,
    subscriptionByPayroll: 25,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['10-24'],
    payfitPackage: PayfitPackageEnum[paieAvancee],
    subscription: 99,
    subscriptionByPayroll: 25,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['25+'],
    payfitPackage: PayfitPackageEnum[paieAvancee],
    subscription: 149,
    subscriptionByPayroll: 25,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  // RH+
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['1-3'],
    payfitPackage: PayfitPackageEnum[rhPlus],
    subscription: 49,
    subscriptionByPayroll: 29,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['4-9'],
    payfitPackage: PayfitPackageEnum[rhPlus],
    subscription: 79,
    subscriptionByPayroll: 29,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['10-24'],
    payfitPackage: PayfitPackageEnum[rhPlus],
    subscription: 99,
    subscriptionByPayroll: 29,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['25+'],
    payfitPackage: PayfitPackageEnum[rhPlus],
    subscription: 149,
    subscriptionByPayroll: 29,
    kanoonPrice: 0,
    expenseModule: 3,
  },
  // PREMIUM
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['1-3'],
    payfitPackage: PayfitPackageEnum.Premium,
    subscription: 49,
    subscriptionByPayroll: 29,
    kanoonPrice: 39,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['4-9'],
    payfitPackage: PayfitPackageEnum.Premium,
    subscription: 79,
    subscriptionByPayroll: 29,
    kanoonPrice: 49,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['10-24'],
    payfitPackage: PayfitPackageEnum.Premium,
    subscription: 99,
    subscriptionByPayroll: 29,
    kanoonPrice: 59,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['25-49'],
    payfitPackage: PayfitPackageEnum.Premium,
    subscription: 149,
    subscriptionByPayroll: 29,
    kanoonPrice: 109,
    expenseModule: 3,
  },
  {
    numberEmployeeRange: NumberEmployeeRangeEnum['50-149'],
    payfitPackage: PayfitPackageEnum.Premium,
    subscription: 149,
    subscriptionByPayroll: 29,
    kanoonPrice: 159,
    expenseModule: 3,
  },
];
